<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    *ngIf="entityInternal"
    class="entityListCard agpr-contextMenu-parent"
>
    <div
        class="entityListCard-container"
        [attr.aria-label]="
            entityInternal.entityType === entityTypes.CONTACT ?
            (entityInternal.firstName + ' ' + entityInternal.lastName)
            : entityInternal.name
        "
        (agprClickUnless)="onCardClicked(entityInternal)"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
        (keydown)="onCardKeydown($event, entityInternal)"
    >
        <div class="checkbox">
            <agpr-checkbox
                [id]="id + '_checkbox'"
                [disabled]="disableSelection"
                [hiddenLabel]="
                    entityInternal.entityType === entityTypes.CONTACT ?
                    (entityInternal.firstName + ' ' + entityInternal.lastName)
                    : entityInternal.name
                "
                [value]="entityInternal"
                [(ngModel)]="selectedResults"
                (onChange)="checkboxClick()"
            ></agpr-checkbox>
        </div>

        <div class="entityListCard-wrapper">
            <div class="entityListCard-row">
                <div class="thumbnail">
                    <img
                        class="thumbnail-img"
                        [agprImageSrc]="entityInternal.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                        alt=""
                        [agprDefaultImage]="imageDefault[entityInternal.entityType]"
                    />
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                        role="img"
                        class="fa-regular fa-duotone fa-check thumbnail-bubble"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                    ></span>
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                        class="thumbnail-bubble"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                    >
                        {{ listMemberships.length }}
                    </span>
                </div>

                <div class="description">
                    <!-- Contact Specific Details -->
                    <ng-container *ngIf="entityInternal.entityType === entityTypes.CONTACT">
                        <div class="description-row">
                            <div class="description-title overflowEllipsis">
                                <a
                                    class="description-title-name"
                                    [id]="entityInternal.id + '_contact_profile'"
                                    agprTooltip="Discover.universal.contactNameLink.tooltip"
                                    tooltipPosition="top"
                                    (click)="onCardClicked(entityInternal)"
                                >
                                    {{entityInternal?.firstName}} {{entityInternal?.lastName}}
                                </a>
                                <span
                                    role="img"
                                    class="fa-solid fa-user description-title-icon"
                                    [attr.aria-label]="'Discover.universal.contactLinkIcon'"
                                ></span>
                            </div>
                        </div>
                        <div
                            *ngIf="entityInternal.selectedEmployment"
                            class="description-jobtitle overflowEllipsis"
                            [pTooltip]="entityInternal.selectedEmployment?.jobTitle"
                            tooltipPosition="top"
                        >
                            {{entityInternal.selectedEmployment?.jobTitle}}
                        </div>
                    </ng-container>
                    <!-- Outlet Specific Details -->
                    <ng-container *ngIf="entityInternal.entityType === entityTypes.OUTLET">
                        <div class="description-row">
                            <div class="description-title overflowEllipsis">
                                <a
                                    class="description-title-name"
                                    [id]="entityInternal.id + '_outlet_profile'"
                                    agprTooltip="Discover.universal.outletLink.tooltip"
                                    tooltipPosition="top"
                                    (click)="onCardClicked(entityInternal)"
                                >
                                    {{entityInternal?.name}}
                                </a>
                                <span
                                    role="img"
                                    class="fa-kit fa-agpr-outlet-solid description-title-icon"
                                    [attr.aria-label]="'Discover.universal.outletLinkIcon'"
                                ></span>
                            </div>
                            <div class="description-spacer"></div>
                        </div>
                        <div *ngIf="entityInternal?.mediaTypes.length > 0">
                            <span
                                *ngFor="let mediaType of entityInternal?.mediaTypes; let last = last"
                            >
                                {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="entityListCard-row">
                @if (entityInternal.entityType === entityTypes.CONTACT) {
                    @if (entityInternal.selectedEmployment?.outlet) {
                        <div class="description-outlet">
                            <agpr-button
                                class="description-outlet-button"
                                [style]="buttonTypes.link"
                                [label]="entityInternal.selectedEmployment.outlet?.name"
                                [tooltip]="entityInternal.selectedEmployment.outlet?.name"
                                tooltipPosition="top"
                                (click)="onCardClicked(entityInternal.selectedEmployment.outlet)"
                            >
                                <span
                                    role="img"
                                    class="fa-kit fa-agpr-outlet-solid description-outlet-icon"
                                    [attr.aria-label]="'Discover.universal.outletLinkIcon'"
                                ></span>
                            </agpr-button>
                        </div>
                    }
                }
                @if (entityInternal.entityType === entityTypes.OUTLET) {
                    @if (entityInternal?.coverageFocus) {
                        <div class="description-coverageFocus">
                            {{entityInternal?.coverageFocus.displayString}}
                        </div>
                    }
                }
                @if (reachValue) {
                    <agpr-meta-data
                        [id]="id"
                        class="description-metadata"
                        [type]="attributeTypes.audienceReach"
                        [icon]="reachIcon"
                        [value]="reachValue"
                        [isSimilarWeb]="isReachValueFromSimilarWeb"
                        [tooltip]="reachUnit"
                    ></agpr-meta-data>
                }
            </div>

        </div>
    </div>
    <div class="agpr-contextMenu top right">
        <agpr-button
            [icon]="'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'"
            tooltip="Discover.entityProfile.expand"
            tooltipPosition="top"
            (click)="onCardClicked(entityInternal)"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        @if (addToType === targetingAddToTypes.LIST) {
            <agpr-button
                class="contextMenu-button"
                [style]="buttonTypes.contextMenu"
                [icon]="'fa-regular fa-duotone fa-user-plus'"
                tooltip="Discover.targeting.actions.manageLists"
                tooltipPosition="top"
                (click)="openManageListDialog(entityInternal)"
            ></agpr-button>
        }
        @if (addToType === targetingAddToTypes.DISTRIBUTION) {
            <agpr-button
                class="contextMenu-button contextMenu-button-manageDist"
                [style]="buttonTypes.contextMenu"
                [icon]="'fa-kit-duotone fa-agpr-add-distribution'"
                tooltip="Discover.targeting.actions.manageDists"
                tooltipPosition="top"
                (click)="openManageDistDialog(entityInternal)"
            ></agpr-button>
        }
    </div>
</div>
